export { truncateDecimalString } from "./truncate-decimal-string";
